import React from 'react';
// eslint-disable-next-line import/no-named-as-default -- posthog-js re-exports its own default as a named `posthog` too
import posthog from 'posthog-js';
import { useDispatch } from 'react-redux';
import {
  DeprecatedModal,
  ModalCancelButton,
  ModalConfirmationButton,
  ModalText,
  ModalTitle,
} from '../../common/DeprecatedModal';
import { cancelEnvelope } from '../../store/envelopeManagement/actions';

interface IProps {
  envelopeId: string;
  close: () => void;
}

const cancelConfig = {
  canceledReason: 'This envelope was not ready to be sent.',
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const CancelModal = (props: IProps) => {
  const dispatch = useDispatch();
  const { envelopeId, close } = props;

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onClickCancel = () => {
    posthog.capture('envelope_cancelled');
    dispatch(cancelEnvelope(envelopeId, cancelConfig));
    close();
  };

  const title = <ModalTitle>Are you sure you want to cancel your envelope?</ModalTitle>;
  const content = (
    <>
      <ModalText>
        Canceling this envelope will remove access for your recipients to sign or view this envelope.
      </ModalText>
    </>
  );
  const actionButtons = (
    <>
      <ModalCancelButton onClick={close} aria-label="keep envelope">
        Keep Envelope
      </ModalCancelButton>
      <ModalConfirmationButton onClick={onClickCancel} aria-label="confirm cancel envelope">
        Cancel Envelope
      </ModalConfirmationButton>
    </>
  );
  return <DeprecatedModal toggleModal={close} title={title} content={content} actionButtons={actionButtons} />;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default CancelModal;
